import { defineStore } from 'pinia'
import { loadAvailableBrandsOptions, loadAvailableLocales } from '@/api/requests/brand/brandRequests'
import { Locale } from '@/types/general/LocaleType'
import { BrandOption } from '@/types/api/brand/brandTypes'

export const useBrandStore = defineStore('brand', {
    state: () => {
        return {
            brands: [] as Array<BrandOption>,
            availableLocalesForBrand: [{
                id: 'en',
                icon: 'en',
                label: 'English',
                value: 'en',
                active: true,
            }] as Array<Locale>,
            localesForAllBrands: [] as Array<Locale>,
        }
    },
    getters: {
        allBrands: (state) => state.brands,
        availableLocales: (state) => state.availableLocalesForBrand as Locale[],
        allLocales: (state) => state.localesForAllBrands as Locale[],
    },

    actions: {
        async loadAvailableBrands() {
            this.brands = await loadAvailableBrandsOptions()
        },
        async loadAvailableLocales(brandId: number|null){
            this.availableLocalesForBrand = await loadAvailableLocales(brandId)
        },
        // Every locale any visible brand supports, deduplicated. Used where a brand cannot be
        // narrowed down - e.g. exporting a selection whose brand the backend resolves itself.
        // Cached: locales per brand do not change within a session.
        async loadAllBrandLocales() {
            if (this.localesForAllBrands.length) return

            if (!this.brands.length) await this.loadAvailableBrands()

            const localesPerBrand = await Promise.all(
                this.brands.map((brand: BrandOption) => loadAvailableLocales(brand.key))
            )
            const merged = new Map<string, Locale>()

            localesPerBrand.flat().forEach((locale: Locale) => {
                if (!merged.has(locale.value)) merged.set(locale.value, locale)
            })

            this.localesForAllBrands = [...merged.values()]
        },
    },
})
